export enum CostCenterColumns {
  Number = 'number',
  Name = 'name',
}
